import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

export interface DeliveryTimeSlot {
  _id?: string;
  timeSlot: string;
  isAvailable: boolean;
  maxOrdersPerSlot: number;
  currentOrders: number;
}

export interface ServiceArea {
  _id?: string;
  name: string;
  pincode: string;
  coordinates: [number, number][]; // [[lat, lng]]
  entryPoint: [number, number]; // [lat, lng]
  isActive: boolean;
  deliveryTimeSlots: DeliveryTimeSlot[];
  createdAt?: string;
  updatedAt?: string;
}

export interface InstantServiceArea {
  _id?: string;
  name: string;
  coordinates: [number, number][]; // [[lat, lng]]
  associatedKitchenId: any; // ID or populated Kitchen object
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const serviceAreasApi = {
  getServiceAreas: async (): Promise<{ success: boolean; data: ServiceArea[] }> => {
    const response = await axios.get(
      `${API_URL}/api/admin/service-areas`,
      getAuthHeaders()
    );
    return response.data;
  },

  getServiceAreaById: async (id: string): Promise<{ success: boolean; data: ServiceArea }> => {
    const response = await axios.get(
      `${API_URL}/api/admin/service-areas/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },

  createServiceArea: async (payload: Partial<ServiceArea>): Promise<{ success: boolean; data: ServiceArea }> => {
    const response = await axios.post(
      `${API_URL}/api/admin/service-areas`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  },

  updateServiceArea: async (id: string, payload: Partial<ServiceArea>): Promise<{ success: boolean; data: ServiceArea }> => {
    const response = await axios.put(
      `${API_URL}/api/admin/service-areas/${id}`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  },

  deleteServiceArea: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await axios.delete(
      `${API_URL}/api/admin/service-areas/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Instant Service Area CRUD API calls
  getInstantServiceAreas: async (): Promise<{ success: boolean; data: InstantServiceArea[] }> => {
    const response = await axios.get(
      `${API_URL}/api/admin/instant-service-areas`,
      getAuthHeaders()
    );
    return response.data;
  },

  getInstantServiceAreaById: async (id: string): Promise<{ success: boolean; data: InstantServiceArea }> => {
    const response = await axios.get(
      `${API_URL}/api/admin/instant-service-areas/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },

  createInstantServiceArea: async (payload: Partial<InstantServiceArea>): Promise<{ success: boolean; data: InstantServiceArea }> => {
    const response = await axios.post(
      `${API_URL}/api/admin/instant-service-areas`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  },

  updateInstantServiceArea: async (id: string, payload: Partial<InstantServiceArea>): Promise<{ success: boolean; data: InstantServiceArea }> => {
    const response = await axios.put(
      `${API_URL}/api/admin/instant-service-areas/${id}`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  },

  deleteInstantServiceArea: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await axios.delete(
      `${API_URL}/api/admin/instant-service-areas/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },
};

export default serviceAreasApi;
